import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import LayoutItem from "./LayoutItem";
import { IonTitle } from "@ionic/react";


export default function Widget({ id, onRemoveItem, layout, render }) {


    const classes = useStyles();

    return (
        <Card className={`${classes.root}`}>
            <div className={`${classes.header} grid-item__title`} style={{ cursor: 'move', }}>
                <IonTitle>
                    {layout.component.displayName}
                </IonTitle>
                <IconButton aria-label="delete" onClick={(e) => {
                    onRemoveItem(id);
                }}>
                    <CloseIcon fontSize="small" />
                </IconButton>
            </div>
            <LayoutItem componentLayout={layout} render={render} />
        </Card>
    );
}

const useStyles = makeStyles({
    root: {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column"
    },
    header: {
        display: "flex",
        alignItems: "center",
        padding: "0.5rem"
    },
    spacer: {
        flexGrow: 1
    },
    body: {
        padding: "0.5rem",
        flexGrow: 1
    }

});